<app-info-panel [isOpen]="isOpen" [title]="title" (closed)="closed.emit()">
  <app-info-panel-section [columns]="1">
    <app-info-panel-field label="Name" i18n-label [value]="run?.runName" />
    <app-info-panel-field label="Description" i18n-label [value]="run?.description" />
  </app-info-panel-section>
  <app-info-panel-section [columns]="2">
    <app-info-panel-field label="Status" i18n-label [value]="run?.status" />
    <app-info-panel-field label="Uploaded On" i18n-label [value]="run?.uploadedOn | utcDate" />
    <app-info-panel-field label="User" i18n-label [value]="run?.user" />
    <app-info-panel-field label="Size" i18n-label [value]="run ? (run.size | fileSize: 'GB') : null" />
    <app-info-panel-list-field label="Groups" i18n-label [value]="run?.groupName?.list" />
  </app-info-panel-section>
</app-info-panel>
